import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=00540916&scoped=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"
import style0 from "./Location.vue?vue&type=style&index=0&id=00540916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00540916",
  null
  
)

export default component.exports